<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="px-2 pt-4 pb-0">
                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="From Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="from_date.value.value"
                        :error-messages="from_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="To Date"
                        density="compact"
                        single-line
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="to_date.value.value"
                        :error-messages="to_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="6">
                      <v-btn class="bg-brand" type="submit" ref="searchButton"
                        >Search</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Lead Record</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12">
                    <div class="text-right pr-2">
                      <v-btn
                        v-if="$insertAccess($route.fullPath)"
                        @click="goTo('/sales/add-crm-lead-v2')"
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi mdi-plus"
                        rounded="xl"
                      >
                        Add Lead
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="getSchema"
                  :loading="loading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  :hover="true"
                  density="compact"
                >
                  <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>

                  <!-- <template v-slot:item.lead_status="{ item }">
                    <v-chip
                      :color="leadStatus[item?.lead_status?.id - 1]?.color"
                      size="small"
                      class=""
                      >
                      {{ item.lead_status?.name }}</v-chip>
                  </template> -->

                  <template v-slot:item.status="{ item }">
                    <v-chip
                      v-if="item.status == 1"
                      color="success"
                      size="small"
                      class="text-capitalize"
                      >Active</v-chip
                    >
                    <v-chip
                      v-else
                      color="red"
                      size="small"
                      class="text-capitalize"
                      >Inactive</v-chip
                    >
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      icon="mdi-pencil-outline"
                      size="small"
                      variant="text"
                      color="orange"
                      @click="editItem(item)"
                      v-if="$updateAccess($route.fullPath) && item?.lead_status?.id != '5'"
                    ></v-btn>

                    <v-btn
                      icon="mdi-eye"
                      size="small"
                      variant="text"
                      color="brown"
                      @click="viewLead(item)"
                    >
                    </v-btn>

                    <v-tooltip text="Daily Update" location="top">
                      <template #activator="{ props }">
                        <v-btn
                          v-bind="props"
                          icon="mdi-update"
                          size="small"
                          variant="text"
                          color="indigo"
                          @click="dailyUpdate(item)"
                          v-if="$updateAccess($route.fullPath)"
                        ></v-btn>
                      </template>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
  <dailyUpdateSetup
    v-model:dialog="dialog"
    :data="data"
    @update:dialog="dialog = $event"
  />
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import { shallowRef } from "vue";
import formattedDate from "@/plugins/dateFormatter";
import leadStatus from "@/utils/leadStatus";
import dailyUpdateSetup from "@/components/module/sales/lead/dailyUpdateSetup.vue";

export default {
  components: {
    dailyUpdateSetup,
  },
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    loading: false,
    search: "",
    dialog: false,
    data: {},
    leadStatus,
    headers: [
      {
        title: "#SL",
        align: "center",
        key: "index",
        width: "7%",
        sortable: false,
      },
      { title: "Code", key: "code", align: "left", sortable: false },
      {
        title: "Company Name",
        key: "company_name",
        align: "left",
        sortable: false,
      },
      {
        title: "Contact Name",
        key: "contact_name",
        align: "left",
        sortable: false,
      },
      {
        title: "Follow up date",
        key: "follow_up_date",
        align: "left",
        sortable: false,
      },
      {
        title: "Next follow up date",
        key: "next_follow_up_date",
        align: "left",
        sortable: false,
      },
      // {
      //   title: "Lead Interest",
      //   align: "center",
      //   key: "lead_interest",
      //   sortable: true,
      // // },
      // {
      //   title: "Lead Status",
      //   align: "center",
      //   key: "lead_status",
      //   sortable: true,
      // },
      // {
      //   title: "Lead Action",
      //   align: "center",
      //   key: "lead_action",
      //   sortable: true,
      // },
      { title: "Status", align: "center", key: "status", sortable: true },
      { title: "Actions", align: "center", key: "actions", sortable: false },
    ],
  }),
  watch: {},
  created() {
    if (this.$store.getters.getSalesLeads.length == 0) {
        this.$store.dispatch("getSalesLeads");
    }
    if(this.$store.getters.getSalesLeadStatus.length === 0) {
        this.$store.dispatch('getSalesLeadStatus');
    }
  },
  computed: {
    getSalesLeadStatus() {
        return this.$store.getters.getSalesLeadStatus;
    },
    getSchema() {
      return this.$store.getters.getSalesLeads;
      // return this.$store.getters.getSalesLeads.filter(
      //   (e) => e.lead_status.id !== 5
      // );
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        // from_date: yup.date().required().label("From Date"),
        // to_date: yup.date().required().label("To Date"),
      }),
    });

    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const errorMessages = ref("");
    const loading = ref("");
    const store = useStore();
    const submit = handleSubmit((values) => {
      loading.value = true;
      values.from_date = formattedDate(from_date.value.value);
      values.to_date = formattedDate(to_date.value.value);
      store
        .dispatch("getSalesLeads", values)
        .then((response) => {
          loading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });
    return {
      submit,
      from_date,
      to_date,
      errorMessages,
      loading,
    };
  },  
  methods: {
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },
    editItem(item) {
      this.$store.commit("setEditingSalesLeads", item);
      this.$router.push({ name: "add-crm-lead-v2", query: {id: item.id} });
    },
    viewLead(item) {
      this.$store.commit("setViewingSalesLeads", item);
      this.$router.push({
        name: "crm-view-lead",
        params: { id: item.id },
      });
    },
    dailyUpdate(item) {
      this.data = { ...item };
      this.dialog = true;
    },
    exportToPDF() {
      let serialNumber = 1;
      const columns = [
        "#SL",
        "Code",
        "Company Name",
        "Contact Name",
        "Follow up",
        "Next follow",
        "Status",
      ];
      const rows = this.getSchema.map((item) => [
        serialNumber++,
        item.code,
        item.company_name,
        item.contact_name,
        item.follow_up_date,
        item.next_follow_up_date,
        item.status == 1 ? "Active" : "Inactive",
      ]);
      this.$exportTableToPDF(
        columns,
        rows,
        "Lead List",
        "lead_list_" + this.$fileDate()
      );
    },
    exportToExcel() {
      var data = [
        [
          "#SL",
          "Code",
          "Company Name",
          "Contact Name",
          "Follow up",
          "Next follow",
          "Status",
        ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([
          serialNumber++,
          item.code,
          item.company_name,
          item.contact_name,
          item.follow_up_date,
          item.next_follow_up_date,
          item.status == 1 ? "Active" : "Inactive",
        ]);
      });
      this.$exportTableToExcel(data, "lead_list_" + this.$fileDate());
    },
    exportToCSV() {
      var data = [
        [
          "#SL",
          "Code",
          "Company Name",
          "Contact Name",
          "Follow up",
          "Next follow",
          "Status",
        ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([
          serialNumber++,
          item.code,
          item.company_name,
          item.contact_name,
          item.follow_up_date,
          item.next_follow_up_date,
          item.status == 1 ? "Active" : "Inactive",
        ]);
      });

      this.$exportTableToCSV(data, "lead_list_" + this.$fileDate());
    },
  },
  mounted() {
    this.from_date.value.value = new Date();
    this.to_date.value.value = new Date();
    this.$nextTick(() => {
      this.$refs.searchButton.$el.click();
    });   
  },
};
</script>
